import service from "./service";

const getInquiries = ({ page = 1, limit = 10, status, search } = {}) => {
  const query = new URLSearchParams();
  if (status && status !== "all") query.set("status", String(status).toLowerCase());
  if (search && String(search).trim()) query.set("search", String(search).trim());
  query.set("page", String(page));
  query.set("limit", String(limit));
  return service.get(`vendors/inquiries?${query.toString()}`);
};
const getInquiry = (id) =>
  service.get(`vendors/inquiries/${encodeURIComponent(id)}`);
const createInquiryQuotation = (id, payload) =>
  service.post(
    `vendors/inquiries/${encodeURIComponent(id)}/quotations`,
    payload,
  );
const getClientSectors = () => service.get("clients/sectors");
const getClientProducts = ({ sector }) =>
  service.get(`clients/products?sector=${encodeURIComponent(sector)}`);
const createRequestQuote = (payload) =>
  service.post("clients/inquiries", payload);
const uploadCompanyDocument = (file) => service.upload("uploads", file);

export default {
  getInquiries,
  getInquiry,
  createInquiryQuotation,
  getClientSectors,
  getClientProducts,
  createRequestQuote,
  uploadCompanyDocument,
};
